import React from "react";

import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function ContentLoader() {
  return (
    <div className={styles.contentLoader}>
      {[...Array(4)].map((_, key) => (
        <div key={key} className={styles.resource}>
          <div className={styles.user}>
            <div className={styles.avatar}>
              <Skeleton className={styles.iconSkeleton} />
            </div>
            <div className={styles.name}>
              <Skeleton className={styles.nameSkeleton} />
              <Skeleton className={styles.professionSkeleton} />
            </div>
          </div>
          <div className={styles.tagsList}>
            <div className={styles.tags}>
              <Skeleton className={styles.tagSkeleton} />
              <Skeleton className={styles.tagSkeleton} />
              <Skeleton className={styles.tagSkeleton} />
              <Skeleton className={styles.tagSkeleton} />
            </div>
          </div>
          <div className={styles.roleSelection}>
            <Skeleton className={styles.textSkeleton} />
          </div>
        </div>
      ))}
    </div>
  );
}

export { ContentLoader };
